import { render, staticRenderFns } from "./audioRecorder.vue?vue&type=template&id=4fbf2ac0&scoped=true"
import script from "./audioRecorder.vue?vue&type=script&lang=js"
export * from "./audioRecorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf2ac0",
  null
  
)

export default component.exports